import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import MenuContext from '../../../context/menuContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';

function TotalPrint({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Print Transfer Ticket"
      left="Cancel"
      right="Continue"
      caption="Do you want to PRINT a transfer ticket?"
    />
  );
}

export default TotalPrint;
